export function getTextStyleLimits(logical?: { width?: number; height?: number } | null) {
  const width = Number(logical?.width) || 2048;
  const height = Number(logical?.height) || 2048;
  const viewMin = typeof window !== 'undefined'
    ? Math.min(window.innerWidth, window.innerHeight)
    : 900;
  const minDim = Math.max(400, Math.min(width, height, viewMin * 2.4));

  return {
    minFontSize: 10,
    maxFontSize: Math.round(Math.min(96, Math.max(48, minDim * 0.045))),
    minCharSpacing: -40,
    maxCharSpacing: Math.round(Math.min(180, Math.max(60, minDim * 0.07))),
    minLineHeight: 0.8,
    maxLineHeight: 2,
  };
}

export function clampNumber(value: number, min: number, max: number) {
  return Math.min(max, Math.max(min, value));
}

export function clampTextStyleProps(
  props: { fontSize?: number; charSpacing?: number; lineHeight?: number },
  limits = getTextStyleLimits(),
) {
  const next = { ...props };
  if (next.fontSize !== undefined) {
    next.fontSize = clampNumber(Number(next.fontSize) || 0, limits.minFontSize, limits.maxFontSize);
  }
  if (next.charSpacing !== undefined) {
    next.charSpacing = clampNumber(Number(next.charSpacing) || 0, limits.minCharSpacing, limits.maxCharSpacing);
  }
  if (next.lineHeight !== undefined) {
    next.lineHeight = clampNumber(Number(next.lineHeight) || 0, limits.minLineHeight, limits.maxLineHeight);
  }
  return next;
}
